import React from 'react';
import ReactDOM from 'react-dom';
import Header from './../Containers/Header';

import Footer from './../Components/Footer'




const header = document.getElementById('header')
const dataTopMenu = JSON.parse(header.getAttribute("data-top_menu"));
const dataBottomMenu = JSON.parse(header.getAttribute("data-bottom_menu"));
const dataPrivateArea = JSON.parse(header.getAttribute("data-private_area"));
const dataLanguages = JSON.parse(header.getAttribute("data-languages"));
const dataLogo = JSON.parse(header.getAttribute("data-logo"));

const dataSearch = JSON.parse(header.getAttribute("data-search"));
ReactDOM.render(<Header search={dataSearch} topMenu={dataTopMenu} logoinfo={dataLogo} bottomMenu={dataBottomMenu} privateArea={dataPrivateArea} languages={dataLanguages}  />, header);





const footer = document.getElementById('footer')
const contacts = JSON.parse(footer.getAttribute('data-contacts'))
const social = JSON.parse(footer.getAttribute('data-social'))
const links = JSON.parse(footer.getAttribute('data-links'))
const logo = footer.getAttribute('data-logo')
const dataDisclaimer = footer.getAttribute("data-disclaimer");
ReactDOM.render(<Footer contacts={contacts} social={social} logo={logo} links={links} disclaimer={dataDisclaimer} />, footer);




// WEBPACK FOOTER //
// ./src/build/header_footer.js